import PublishRes from "./publish-res";
import React from "react";

function UploadScreen() {
  return <PublishRes />;
}
export default UploadScreen;